// src/redux/settingsPages/legalConsent/legalConsentActions.js
import { createAsyncThunk } from '@reduxjs/toolkit';
import LegalConsentAPI from './legalConsentAPI';

export const fetchLegalConsent = createAsyncThunk(
  'legalConsent/fetch',
  async (_, { rejectWithValue }) => {
    try {
      return await LegalConsentAPI.getConsent();
    } catch (err) {
      return rejectWithValue(err?.response?.data?.detail || err.message || 'Failed to load consent status');
    }
  }
);

export const updateLegalConsent = createAsyncThunk(
  'legalConsent/update',
  async (patch, { rejectWithValue }) => {
    try {
      return await LegalConsentAPI.patchConsent(patch);
    } catch (err) {
      return rejectWithValue(err?.response?.data?.detail || err.message || 'Failed to update consent');
    }
  }
);
